

import {
  FrontCover,
  StaticPage1,
  StaticPage2,
  StaticPage3,
  StaticPage4,
  BirdPage1,
  BirdPage2,
  StaticPage5,
  StaticPage6,
  OwlPage1,
  OwlPage2,
  BearPage1,
  BearPage2,
  GiraffePage1,
  GiraffePage2,
  ButterflyPage1,
  ButterflyPage2,
  CrabPage1,
  CrabPage2,
  PeacockPage1,
  PeacockPage2,
  AnimalPage1,
  AnimalPage2,
  AnimalPage3,
  AnimalPage4,
  ElephantPage1,
  ElephantPage2,
  BoyPage1,
  BoyPage2,
  StarPage1,
  StarPage2,
  RoutePage1,
  RoutePage2,
  CountPage1,
  CountPage2,
  LastPage1,
  Lastpagetwo,
} from "./textfile";

export const staticPages = {
  frontCover: FrontCover,
  staticpage1: StaticPage1,
  staticpage2: StaticPage2,
  staticpage3: StaticPage3,
  staticpage4: StaticPage4,
  birdpage1: BirdPage1,
  birdpage2: BirdPage2,
  staticpage5: StaticPage5,
  staticpage6: StaticPage6,
  owlpage1: OwlPage1,
  owlpage2: OwlPage2,
  bearpage1: BearPage1,
  bearpage2: BearPage2,
  giraffepage1: GiraffePage1,
  giraffepage2: GiraffePage2,
  butterflypage1: ButterflyPage1,
  butterflypage2: ButterflyPage2,
  crabpage1: CrabPage1,
  crabpage2: CrabPage2,
  peacockpage1: PeacockPage1,
  peacockpage2: PeacockPage2,
  animalpage1: AnimalPage1,
  animalpage2: AnimalPage2,
  animalpage3: AnimalPage3,
  animalpage4: AnimalPage4,
  elephantpage1: ElephantPage1,
  elephantpage2: ElephantPage2,
  boypage1: BoyPage1,
  boypage2: BoyPage2,
  starpage1: StarPage1,
  starpage2: StarPage2,
  routepage1: RoutePage1,
  routepage2: RoutePage2,
  countpage1: CountPage1,
  countpage2: CountPage2,
  lastpage1: LastPage1,
  lastpage2: Lastpagetwo,
};

export const pageStyle = {
  position: "relative",
  minHeight: "200mm",
  height: "200mm",
  width: "200mm",
  maxWidth: "200mm",
};

export function getPages(book) {
  return [
    { name: "frontCover" },
    { name: "staticpage1" },
    { name: "staticpage2" },
    { name: "staticpage3" },
    { name: "staticpage4" },
    { name: "birdpage1" },
    { name: "birdpage2", assetname: "bird" },
    { name: "staticpage5" },
    { name: "staticpage6" },
    { name: "owlpage1", assetname: "owl" },
    { name: "owlpage2" },
    { name: "bearpage1", assetname: "bear" },
    { name: "bearpage2" },
    { name: "giraffepage1", assetname: "giraffe" },
    { name: "giraffepage2" },
    { name: "butterflypage1" },
    { name: "butterflypage2", assetname: "butterfly" },
    { name: "crabpage1" },
    { name: "crabpage2", assetname: "crab" },
    { name: "peacockpage1", assetname: "peacock" },
    { name: "peacockpage2" },
    { name: "animalpage1", assetname: "animal" },
    { name: "animalpage2" },
    { name: "animalpage3", assetname: "animal" },
    { name: "animalpage4" },
    { name: "elephantpage1", assetname: "elephant" },
    { name: "elephantpage2" },
    { name: "boypage1", assetname: "boy" },
    { name: "boypage2" },
    { name: "starpage1" },
    { name: "starpage2", assetname: "star" },
    { name: "routepage1", assetname: "route" },
    { name: "routepage2" },
    { name: "countpage1", assetname: "count" },
    { name: "countpage2" },
    { name: "lastpage1", assetname: "last" },
    { name: "lastpage2" },
  ]
    .map((o, i) => ({
      pagetype: "fullimage",
      contentSize: 200,
      label: i === 0 ? "Frontpage" : i === 36 ? "Backcover" : i + 1,
      content: book && book[o.name],
      ...o,
    }));
}
